module.exports = __webpack_public_path__ + "img/title_1.85eb2651.png";